import { toast } from 'react-toastify'
import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import { learningApi } from '../../../services/api'
import { RootState } from '../rootReducer'
import { fetchSubscriptions } from './actions'
import { SubscriptionTypes } from './types'

function* getSubscriptionsOnce() {
  try {
    const { token, status } = yield select((state: RootState) => ({
      token: state.auth.token,
      status: state.subscription.status,
    }))

    if (!token) return
    if (status !== 'idle') return

    yield put(fetchSubscriptions.request())

    const subscriptionResponse = yield call(learningApi.get, '/subscription', {
      headers: { Authorization: `Bearer ${token}` },
    })

    if (!subscriptionResponse) {
      const error = { response: { data: 'Network Error' } }
      throw error
    }

    const { subscriptions, message } = subscriptionResponse.data

    yield put(fetchSubscriptions.success({ subscriptions: message ? [] : subscriptions }))
  } catch (error) {
    if (error?.response?.status !== 401) {
      toast.error('Não foi possível carregar suas assinaturas. tente novamente mais tarde.')
    }

    yield put(fetchSubscriptions.failure({ error: error.response }))
  }
}

export default all([takeEvery(SubscriptionTypes.GET_SUBSCRIPTIONS_ONCE, getSubscriptionsOnce)])
